import { ORM, ArrayField, ObjectField } from "./CouchORM";
import {db} from '../Database.svelte';
import { sortBy } from "lodash-es";
import parseFields from "../Utilities/parseFields";

export default class Library extends ORM {
    static fields = {
        items: ArrayField("items", ObjectField),
        fields: ArrayField("fields", ObjectField),
        moderation_queue: ArrayField("moderation", ObjectField)
    }

    static collectionType = "Library";

    static async getFieldData(library_id) {
        let fields = await getFields(library_id);

        return parseFields(fields);
    }

    static async getModerationItems(library_id) {
        let moderation_items = await db.allDocs({
            startkey: `${library_id}:moderation_queue:`,
            endkey: `${library_id}:moderation_queue:~`
        });

        return moderation_items;
    }
}

export async function getFields(library_id) {
    let results = await db.allDocs({
        startkey: `${library_id}:fields:`,
        endkey: `${library_id}:fields:~`,
        include_docs: true
    });

    return sortBy(results.rows.map(r => r.doc), ['rank_']);
}

export function getItem(item_id) {
    return db.get(item_id);
}